import { WPN_POPUP_STATUS } from '../../../../global-store/subjects/auto-push-notifications/get-actions';
import { commonActions } from '../../../../global-store/subjects/common';
import { getLabel } from '../../../../labels/labelling-service';
import { satelliteTracker } from '../../../../services/tracking/satellite-tracking-service';
import { WPN_ANALYTICS_EVENTS } from '../../../../utils/analytics';
import { RESPONSIVE_OFFSETS } from '../../../../utils/constants';
import { closeBurgerMenu, scrollToElement } from '../../../../utils/dom-utils';
import { setDailySessionOnLocalStorage, WPN_DAILY_SESSION, WPN_STATUS } from '../../../../utils/local-storage';
import {
  optOut,
  setOptionsFromSdk,
  setOptionsToSdk,
  getAnalyticsTopics,
  getAnalyticsCategories,
  showPreferencesDialog,
  initDefaultOptions,
} from '../../../../utils/push-notifications-utils';

const getHandleShowConfirmModal = (actions) => () => {
  actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL);
  commonActions.setPushNotificationInDialogShow(true);
  satelliteTracker.trackInWeb(WPN_ANALYTICS_EVENTS.OPEN);
  setDailySessionOnLocalStorage(WPN_DAILY_SESSION.OBJECT_KEY, WPN_DAILY_SESSION.EXPIRATION_DAYS);
};

const getHandleWPNAccept = (actions) => async (selectBoxes) => {
  if (Notification?.permission !== 'granted' && Notification.requestPermission) {
    try {
      const state = await Notification.requestPermission();
      if (state) {
        showPreferencesDialog({ notificationPermission: state, selectBoxes, actions });
      }
    } catch (error) {
      console.error(`[WPN] There has been a problem with request permission: ${error.message}`);
    }
  } else {
    showPreferencesDialog({ notificationPermission: 'granted', selectBoxes, actions });
  }

  satelliteTracker.trackInWeb(WPN_ANALYTICS_EVENTS.JOIN);
};

const getHandleConfirmModalCancel = (actions) => (selectBoxes, allUnchecked) => {
  initDefaultOptions({ selectBoxes, actions, allUnchecked });
  actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
  console.error('[WPN] Not subscribed - NOT NOW --> KO');
};

const getHandleConfirmModalClose = (actions) => (selectBoxes, allUnchecked) => {
  initDefaultOptions({ selectBoxes, actions, allUnchecked });
  actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
  console.error('[WPN] Not subscribed - CLOSED --> KO_SOFT');
};

const getHandleWPNunsubscribe = (actions) => () => {
  actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_PREFERENCES_UNSUBSCRIBE_CONFIRM);
};

const getHandleWPNunsubscribeConfirm = (sdk, actions) => async () => {
  try {
    await optOut(sdk);
    actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_PREFERENCES_UNSUB_SUCCESS);
    setTimeout(() => {
      actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
    }, 3000);
  } catch (error) {
    console.error(`[WPN] UA - error trying to optOut: ${error}`);
  }
};

const getHandlePreferencesDialogClose = (sdk, actions) => (selectBoxes) => {
  setOptionsFromSdk({ sdk, selectBoxes, actions });
  actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
};

const getHandleGenericDialogClose = (actions) => () => {
  actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
};

const getHandlePreferencesDialogConfirm = (sdk, actions) => async (selectBoxes, selectedOptions) => {
  try {
    await setOptionsToSdk({ sdk, selectBoxes, selectedOptions });
    actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL_SUCCESS);
    setTimeout(() => {
      actions.setPopupStatus(WPN_POPUP_STATUS.NOTHING_IS_SHOWN);
    }, 3000);

    const categoriesAndTopics = {
      category: getAnalyticsCategories(selectBoxes, selectedOptions),
      name: getAnalyticsTopics(selectBoxes, selectedOptions),
    };
    satelliteTracker.trackInWeb(WPN_ANALYTICS_EVENTS.EDIT, categoriesAndTopics);
  } catch (error) {
    console.error(error);
  }
};

const getHandleWPNEditClick = (sdk, actions) => (selectBoxes) => {
  satelliteTracker.trackInWeb(WPN_ANALYTICS_EVENTS.ICONA);

  closeBurgerMenu();

  if (!sdk?.channel?.optedIn) {
    initDefaultOptions({ selectBoxes, actions });
  }
  if (Notification?.permission === 'granted') {
    actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_PREFERENCES_POPUP);
  } else {
    actions.setPopupStatus(WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL);
    satelliteTracker.trackInWeb(WPN_ANALYTICS_EVENTS.OPEN);
  }
};

const getHandleOptionClick = (state, actions) => (selectBoxName, option) => {
  const currentSelectedOptions = state.selectedOptions[selectBoxName];
  let newSelectedOptions;
  if (currentSelectedOptions?.length) {
    newSelectedOptions = currentSelectedOptions.includes(option.value)
      ? currentSelectedOptions.filter((selectedOption) => selectedOption !== option.value)
      : [...currentSelectedOptions, option.value];
  } else {
    newSelectedOptions = [option.value];
  }
  actions.setSelectedOptions(selectBoxName, newSelectedOptions);
};

const getHandleSwitchClick = (actions) => (selectBox, checked) => {
  const newSelectedOptions = checked ? [] : selectBox.options.map((option) => option.value);
  actions.setSelectedOptions(selectBox.boxName, newSelectedOptions);
};

export const getHandlers = ({ state, actions }) => ({
  handleShowConfirmModal: getHandleShowConfirmModal(actions),
  handleWPNAccept: getHandleWPNAccept(actions),
  handleConfirmModalCancel: getHandleConfirmModalCancel(actions),
  handleConfirmModalClose: getHandleConfirmModalClose(actions),
  handleWPNunsubscribe: getHandleWPNunsubscribe(actions),
  handleWPNunsubscribeConfirm: getHandleWPNunsubscribeConfirm(state.sdk, actions),
  handlePreferencesDialogClose: getHandlePreferencesDialogClose(state.sdk, actions),
  handlePreferencesDialogConfirm: getHandlePreferencesDialogConfirm(state.sdk, actions),
  handleGenericDialogClose: getHandleGenericDialogClose(actions),
  handleWPNEditClick: getHandleWPNEditClick(state.sdk, actions),
  handleOptionClick: getHandleOptionClick(state, actions),
  handleSwitchClick: getHandleSwitchClick(actions),
});
